import React, { HTMLAttributes } from 'react'

import HeadingNew from 'presentation/shared/components/HeadingNew'
import SupportTextNew from 'presentation/shared/components/SupportTextNew'
import { ReactComponent as InfoIcon } from 'presentation/assets/icons/info-new.svg'

import * as S from './styles'

export type SystemRecoveryCardProps = HTMLAttributes<HTMLDivElement>

const SystemRecoveryCard = ({ ...props }: SystemRecoveryCardProps) => (
  <S.InfoCard {...props}>
    <S.InfoCardTitle>
      <InfoIcon />
      <HeadingNew size="medium" color="info950" weight="semiBold">
        Meu Mater Dei está de volta!
      </HeadingNew>
    </S.InfoCardTitle>
    <SupportTextNew
      size="small"
      color="info950"
      fontFamily="secondary"
      style={{ lineHeight: 1.5 }}
    >
      Poderão ocorrer instabilidades pontuais durante o processo de
      estabilização. Agradecemos sua compreensão.
    </SupportTextNew>
  </S.InfoCard>
)

export default SystemRecoveryCard
